import React from "react";

const National = () => {
  return (
    <div className="py-32 bg-slate-200">
      <div className="container mx-auto px-5">
        <div>
          <h3 className="text-6xl font-bold pb-5">
            A National Track Record of Success
          </h3>
        </div>
        <div className="flex justify-center mt-10">
          <img src="images/body/map.png" className="object-cover" alt="img" />
        </div>
      </div>
    </div>
  );
};

export default National;
